import { Grid, Pagination, Stack } from '@mui/material';
import Link from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

import PageMargins from '@/components/ui/PageMargins/PageMargins';
import blogConfig from '@/configs/blog';
import { blogCategoryPropType, blogPostPropType } from '@/constants/propTypes';

import { PaginationItem } from './BlogPostsListPage.style';
import Filters from './Filters/Filters';
import Heading from './Heading/Heading';
import Tile from './Tile/Tile';

const BlogPostsListPage = ({ pageData, categories }) => {
  const router = useRouter();

  return (
    <div>
      <PageMargins>
        <Heading />
        <Filters
          activeCategory={router.query.category}
          categories={categories}
        />
        <Grid
          container
          columnSpacing={{ md: 3.5, xs: 2 }}
          rowSpacing={{ xs: 5, md: 12.5 }}
          mb={7.5}>
          {pageData.data.map(blogPost => (
            <Grid
              data-test-subject="blog-list-element"
              item
              lg={4}
              sm={6}
              xs={12}
              key={blogPost.id}>
              <Tile data={blogPost} query={router.query} />
            </Grid>
          ))}
        </Grid>
        <Stack alignItems="center" mt={6} mb={19}>
          {pageData.meta.pagination.pageCount > 1 && (
            <Pagination
              count={pageData.meta.pagination.pageCount}
              page={pageData.meta.pagination.page}
              variant="outlined"
              shape="rounded"
              size="large"
              renderItem={item => {
                const shouldShowArrowLink =
                  item.page > 0 &&
                  item.page <= pageData.meta.pagination.pageCount;
                return (
                  <PaginationItem
                    component={shouldShowArrowLink ? Link : 'span'}
                    {...(shouldShowArrowLink && {
                      href: `${blogConfig.basePathname}/${router.query.category}?page=${item.page}`,
                    })}
                    {...item}
                  />
                );
              }}
            />
          )}
        </Stack>
      </PageMargins>
    </div>
  );
};

BlogPostsListPage.propTypes = {
  pageData: PropTypes.shape({
    data: PropTypes.arrayOf(blogPostPropType).isRequired,
    meta: PropTypes.object.isRequired,
  }).isRequired,
  categories: PropTypes.arrayOf(blogCategoryPropType).isRequired,
};

export default BlogPostsListPage;
